module.exports = __webpack_public_path__ + "static/media/orders-document.a16b533a.svg";